export default {
      id: "stop-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#stop-usage",
      toString: function () {
        return this.url;
      }
    }